import React from 'react';

import CommonImage from './CommonImage';

const DEFAULT_OPTIONS = [
	{ id: 'PRESENTATION', title: 'Presentation Link', value: 'PRESENTATION' },
	{ id: 'DOWNLOAD_REPORT', title: 'Techpack Summary', value: 'DOWNLOAD_REPORT' },
	{ id: 'SAMPLE_LOCATION_DETAILS', title: 'Sample Location Details', value: 'SAMPLE_LOCATION_DETAILS' }
];

const BottomPopupDropdownOptions = ({
	onActionClick,
	options = DEFAULT_OPTIONS,
	title = 'Download',
	showIcon = true,
	icon = `/icons/download-gray-dark-02.svg`
}) => {
	// Generate unique ID for each instance
	const dropdownId = React.useId();

	return (
		<div className="dropdown collection-bottom-sub-popup">
			<button
				className="button text size32 px-0"
				type="button"
				id={`downloadDropdown__${dropdownId}`}
				data-toggle="dropdown"
				aria-haspopup="true"
				aria-expanded="false"
			>
				{showIcon && <CommonImage src={icon} alt="button-icon" className="mr-1" />}
				{title}
			</button>
			<div className="dropdown-menu" aria-labelledby={`downloadDropdown__${dropdownId}`}>
				<ul>
					{options.map((option) => (
						<li key={option?.id} onClick={() => onActionClick(option?.value)}>
							<span>{option?.title}</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default BottomPopupDropdownOptions;
